// eslint-disable-next-line import/no-extraneous-dependencies
import { slideUp, slideDown, slideToggle } from './libs/slide';
import Swiper from 'swiper/bundle';

if(document.querySelector('.js-index-slide') !== null) {
  const indexBtn = document.querySelector('.article-contents-index__btn');
  indexBtn.addEventListener('click', function(){
    document.querySelector('.article-contents-index').classList.add('list-smart');
    this.classList.add('d-none');
  });
}
